// extracted by mini-css-extract-plugin
export default {"profileUpload":"style_profileUpload__cx81X","submitButton":"style_submitButton__C0B6L"};